/**
 * Liste des domaines d'emails privés (non professionnels)
 * Cette liste doit être synchronisée avec celle du backend (app/utils/email.py)
 */
const PRIVATE_EMAIL_DOMAINS = new Set([
    // Domaines globaux majeurs
    "gmail.com", "yahoo.com", "hotmail.com", "outlook.com", "live.com",
    // Domaines US classiques
    "aol.com", "icloud.com", "protonmail.com", "mail.com", "zoho.com",
    // Domaines internationaux
    "yandex.com", "gmx.com", "me.com", "tutanota.com", "fastmail.com",
    // Domaines ISP US
    "msn.com", "comcast.net", "rediffmail.com", "qq.com", "naver.com",
    // Domaines Asie
    "163.com", "126.com", "sina.com", "web.de", "mail.ru", "cox.net",
    // Domaines UK
    "btinternet.com", "bellsouth.net", "verizon.net", "earthlink.net",
    "optonline.net", "charter.net", "shaw.ca", "sky.com", "rogers.com",
    "att.net", "ntlworld.com", "talktalk.net", "virginmedia.com",
    "blueyonder.co.uk", "bt.com", "sbcglobal.net", "frontier.com",
    // Domaines alternatifs
    "juno.com", "netzero.net", "aim.com", "zoho.eu", "gmx.net",
    // Domaines sécurisés
    "hushmail.com", "lycos.com", "mailfence.com", "runbox.com",
    // Domaines européens
    "posteo.de", "seznam.cz", "tiscali.co.uk", "virgin.net",
    // Domaines France
    "wanadoo.fr", "orange.fr", "free.fr", "laposte.net", "sfr.fr",
    "neuf.fr", "club-internet.fr",
    // Domaines Italie
    "libero.it", "virgilio.it", "alice.it", "tin.it", "tiscali.it",
    "email.it", "fastwebnet.it", "vodafone.it", "live.it", "tim.it", "wind.it",
    // Domaines UK spécifiques
    "yahoo.co.uk", "hotmail.co.uk", "outlook.co.uk", "gmail.co.uk", "btconnect.com",
    "btinternet.com", "btopenworld.com",
    // Variantes Gmail
    "gmail.fr", "gmail.de", "gmail.it", "gmail.es", "gmail.com.br", "gmail.com.au",
    // Variantes Yahoo régionales
    "yahoo.fr", "yahoo.de", "yahoo.it", "yahoo.es", "yahoo.com.br", "yahoo.com.au",
    // Variantes Hotmail régionales
    "hotmail.fr", "hotmail.de", "hotmail.it", "hotmail.es", "hotmail.com.br", "hotmail.com.au",
    // Variantes Outlook régionales
    "outlook.fr", "outlook.de", "outlook.it", "outlook.es", "outlook.com.br", "outlook.com.au",
    // Autres domaines courants
    "ymail.com", "rocketmail.com", "ymail.fr", "gmx.fr", "gmx.de", "gmx.com",
    "mailinator.com", "10minutemail.com", "guerrillamail.com", "tempmail.com"
]);

/**
 * Vérifie si un email est un email privé (non professionnel)
 * @param email - L'adresse email à vérifier
 * @returns true si l'email est un email privé, false sinon
 */
export const isPrivateEmail = (email: string): boolean => {
    if (!email || typeof email !== 'string') {
        return false;
    }
    
    const normalizedEmail = email.toLowerCase().trim();
    const domain = normalizedEmail.split('@')[1];
    
    if (!domain) {
        return false;
    }
    
    return PRIVATE_EMAIL_DOMAINS.has(domain);
};

/**
 * Valide le format d'un email
 * @param email - L'adresse email à valider
 * @returns true si l'email a un format valide, false sinon
 */
export const validateEmailFormat = (email: string): boolean => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
};

/**
 * Valide qu'un email est professionnel (non privé)
 * @param email - L'adresse email à valider
 * @returns true si l'email est professionnel, false sinon
 */
export const isProfessionalEmail = (email: string): boolean => {
    return validateEmailFormat(email) && !isPrivateEmail(email);
};
